import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import React from "react";
import { T } from "services/lang/LanguageService";

interface DatasetIDSearchFieldProps {
  idNumber: number | undefined;
  selectedType: string;
  typesOfDataset: string[];
  setIdNumber: (value: number) => void;
  setSelectedType: (value: string) => void;
}

const DatasetIDSearchField = ({
  idNumber,
  selectedType,
  typesOfDataset,
  setIdNumber,
  setSelectedType,
}: DatasetIDSearchFieldProps) => {
  return (
    <div className="h-min flex flex-row align-items-center">
      <div className="w-2 h-min">
        <label htmlFor="datasetId">{T("action.search-by-dataset-id")}:</label>
        <InputNumber
          id="datasetId"
          className="mt-2"
          value={idNumber}
          onValueChange={(e: any) => setIdNumber(e.value as number)}
          min={0}
          autoFocus
          format={false}
        />
      </div>
      <p className="font-semibold text-2xl mt-6 mb-4 ml-3 mr-3">:</p>
      <div className="w-10 h-min">
        <label htmlFor="datasetType">{T("action.select-dataset-class")}:</label>
        <Dropdown
          id="datasetType"
          className="w-full mt-2"
          value={selectedType}
          options={typesOfDataset}
          onChange={e => setSelectedType(e.value)}
          editable
        />
      </div>
    </div>
  );
};

export default DatasetIDSearchField;
